import moment from "moment";
import { DB_DATE_FORMAT } from "../../../redux/constants";
export const getStartEndDatesByMonthYear = (_month, _year) => {
    const startOFDate = `${_month}-01-${_year}`;
    const startDate = moment(startOFDate, DB_DATE_FORMAT)
        .startOf("month")
        .format(DB_DATE_FORMAT);
    const endDate = moment(startOFDate, DB_DATE_FORMAT)
        .endOf("month")
        .format(DB_DATE_FORMAT);
    return { startDate, endDate };
};

export const getWeekDaysByMonthYear = (_month, _year) => {
    const weekDays = [];
    const startOFDate = `${_month}-01-${_year}`;
    const getNumWeeksForMonth = (year, month) => {
        let date = new Date(year, month - 1, 1);
        let day = date.getDay();
        let numDaysInMonth = new Date(year, month, 0).getDate();
        return Math.ceil((numDaysInMonth + day) / 7);
    };
    const weekCount = getNumWeeksForMonth(_year, _month);
    let weekNo = moment(startOFDate, DB_DATE_FORMAT).weeks();
    const noOfIterations = weekCount - 1 + weekNo;
    while (weekNo <= noOfIterations) {
        const firstWeekdate = moment(startOFDate, DB_DATE_FORMAT).weeks(weekNo);
        let weekStart = moment(moment(firstWeekdate).startOf("week"));
        let weekEnd = moment(moment(firstWeekdate).endOf("week"));
        weekDays.push({
            startDate: weekStart.format(DB_DATE_FORMAT),
            endDate: weekEnd.format(DB_DATE_FORMAT),
        });
        weekNo++;
    }
    return weekDays;
};
export const getWeekDays = (_year) => {
    let weekArrays = [];
    let weekNo = 1;
    let maxWeeks = weeksInYear(_year);

    const firstWeekdate = moment(`01-01-${_year}`, DB_DATE_FORMAT).weeks(
        weekNo
    );
    let weekStart = moment(moment(firstWeekdate).startOf("week"));
    let weekEnd = moment(moment(firstWeekdate).endOf("week"));
    while (weekNo <= moment(weekEnd).weeks() && weekNo <= maxWeeks) {
        weekArrays.push({
            startDate: weekStart.format(DB_DATE_FORMAT),
            endDate: weekEnd.format(DB_DATE_FORMAT),
        });
        weekStart = weekStart.add(7, "day");
        weekEnd = weekEnd.add(7, "day");
        weekNo++;
    }
    return weekArrays;
};

const getWeekNumber = (d) => {
    let _d = d;
    // Copy date so don't modify original
    _d = new Date(+d);
    _d.setHours(0, 0, 0);
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    _d.setDate(_d.getDate() + 4 - (_d.getDay() || 7));
    // Get first day of year
    let yearStart = new Date(_d.getFullYear(), 0, 1);
    // Calculate full weeks to nearest Thursday
    let weekNo = Math.ceil(((_d - yearStart) / 86400000 + 1) / 7);
    // Return array of year and week number
    return [_d.getFullYear(), weekNo];
};
const weeksInYear = (year) => {
    let month = new Date().getMonth(),
        day = new Date().getDate(),
        week;
    if (year < moment().year()) {
        month = "11";
        day = 31;
    }

    // Find week that 31 Dec is in. If is first week, reduce date until
    // get previous week.
    do {
        let d = new Date(year, month, day--);
        week = getWeekNumber(d)[1];
    } while (week == 1);

    return week;
};
